import { Injectable } from '@angular/core';
import { CondicaoDePagamento } from '../models/condicao-de-pagamento';
import { GlobalService } from './global.service';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CondicaoDePagamentoService {

  constructor(private http: HttpClient) {

  }

  consultar(status = 1, idForma?) {
    return this.http.get<CondicaoDePagamento[]>(globals.apiUrl + '/api/CondPag/Listar',
      { params: new HttpParams().set('status', status.toString()).set('idForma', idForma !== null && idForma !== undefined ? idForma : '') });
  }

  consultarPorId(id) {
    return this.http.get<CondicaoDePagamento>(globals.apiUrl + '/api/CondPag/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(condicaoDePagamento: CondicaoDePagamento) {
    return this.http.post(globals.apiUrl + '/api/CondPag/Salvar', condicaoDePagamento);
  }

  bloquear(id) {
    return this.http.get(globals.apiUrl + '/api/CondPag/Bloquear',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorForma(idForma, status = 1, taxaZero?) {

    let parametros = new HttpParams().set('idForma', idForma)
      .set('status', status.toString());

    if (taxaZero !== null && taxaZero !== undefined) {
      parametros = parametros.set('taxaZero', taxaZero);
    }

    return this.http.get<CondicaoDePagamento[]>(globals.apiUrl + '/api/CondPag/ListarPorForma',
      {
        params: parametros
      });
  }

  consultarPorFormas(formas, status = 1) {
    return this.http.get<CondicaoDePagamento[]>(globals.apiUrl + '/api/CondPag/ListarPorFormas',
      {
        params: new HttpParams().set('formas', formas)
          .set('status', status.toString())
      });
  }

  verificaForaDoLimite(condicao: CondicaoDePagamento, valor: number): boolean {
    const foraDoLimiteMinimo = condicao.valorMinimo > 0 && valor < condicao.valorMinimo;
    const foraDoLimiteMaximo = condicao.valorMaximo > 0 && valor > condicao.valorMaximo;

    return foraDoLimiteMinimo || foraDoLimiteMaximo;
  }
}
